import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

class Toast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      timer: null
    };
    this.startTimer = this.startTimer.bind(this);
    this.handleExitButtonClick = this.handleExitButtonClick.bind(this);
  }

  startTimer () {
    const { time = 2000 } = this.props;
    const timer = setTimeout(()=>{
      this.setState({ show : false, timer : null })
    }, time);
    this.setState({ timer });
  }

  handleExitButtonClick () {
    this.setState({
      show: false
    });
  }

  componentDidUpdate (prevProps) {
    if (prevProps.show === this.props.show) return;
    if (this.props.show) {
      this.setState({
        show: true
      }, this.startTimer());
    } else if (this.state.timer) {
      clearTimeout(this.state.timer);
      this.setState({ timer: null, show: false });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.state.timer);
  }

  render() {
    const { error, backgroundColor } = this.props;
    let toastText;
    if (this.props.text) {
      toastText = this.props.text;
    } else {
      toastText = !error ?
        <FormattedMessage id="shared-components.toast.text" defaultMessage="Changes saved" />
        :
        <FormattedMessage id="toast-text" defaultMessage="Error, please check changes" />;
    }

    const toastClasses = `toast-wrapper flex space-between middle ${this.state.show ? "toast-show" : ""} ${error ? "toast-error": ""}`;
    return (
      <div data-testing-id="toast-wrapper" className={toastClasses}style={backgroundColor ? { backgroundColor } : {}}>
        <p className="toast-text">{toastText}</p>
        <button className="toast-exit" onClick={this.handleExitButtonClick}>&times;</button>
      </div>);
  }
}

export default injectIntl(Toast);
